import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import { RadioGroupContext } from '../RadioGroupContext';

import styles from './RadioGroupBase.module.css';
import { RadioGroupBaseProps } from './types';

export default function RadioGroupBase<Option = undefined>({
  options,
  radioProps,
  layout = 'horizontal',
  classNameRoot,
  renderRadio,
  onChange,
  value,
  children,
  name,
  id
}: PropsWithChildren<RadioGroupBaseProps<Option>>) {
  const radioGroupBaseClassNames: string = clsx(
    styles.radioGroupBaseRoot,
    classNameRoot,
    { [styles.horizontal]: layout === 'horizontal' },
    { [styles.vertical]: layout === 'vertical' },
  );
  return (
    <RadioGroupContext.Provider value={{ onChange, name, value }}>
      <div className={radioGroupBaseClassNames} role="radiogroup">
        {children}
        {options?.map((option: any, idx: number) =>
          renderRadio({
            ...option,
            ...radioProps,
            checked: option.checked || option.value == value,
            onClick: (event: React.MouseEvent<HTMLElement>): void => {
              event.stopPropagation();
              option.onClick && option.onClick();
            },
            key: idx,
            id: id,
          }),
        )}
      </div>
    </RadioGroupContext.Provider>
  );
}
